import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pc-view-tx" }
const _hoisted_2 = { class: "head flex-between" }

import { watch, computed } from "vue";
import { filterHash } from "@/utils/filters";
import HomeMixins from "@/mixins/home";
import Count from "@/components/common/Count.vue";
import Store from "@/store/index";


export default /*@__PURE__*/_defineComponent({
  __name: 'TxArea',
  setup(__props) {

const { txLists, getTxList } = HomeMixins();
const maxHeight = computed(() => Store.state.maxHeight);

watch(
  maxHeight,
  () => {
    getTxList();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", null, "最新数据", -1)),
      _createVNode(_component_router_link, {
        to: "/tradelist",
        class: "link"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("查看全部")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: _unref(txLists).list,
      stripe: "",
      style: {"width":"100%"},
      class: "data-table"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "上链哈希",
          align: "center",
          width: "200"
        }, {
          default: _withCtx((item) => [
            _createVNode(_component_router_link, {
              to: `/tradeHash?hash=${item.row.hash}`,
              class: "light"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(filterHash)(item.row.hash)), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "hash",
          label: "发送地址",
          align: "center"
        }, {
          default: _withCtx((item) => [
            _createVNode(_component_router_link, {
              to: `/address?address=${item.row.from}`,
              class: "light"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(filterHash)(item.row.from, 20)), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "txCount",
          label: "接收地址",
          align: "center",
          width: "300"
        }, {
          default: _withCtx((item) => [
            _createVNode(_component_router_link, {
              to: `/address?address=${item.row.to}`,
              class: "light"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(filterHash)(item.row.to, 20)), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "blockTime",
          label: "上链时间",
          align: "center",
          width: "200"
        }, {
          default: _withCtx((item) => [
            _createVNode(Count, {
              time: item.row.block_time
            }, null, 8, ["time"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})